module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/firstStep-e5cd691701f76a9f3a62bc1c96281a0e.png";